import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-fiche-footing',
  templateUrl: './fiche-footing.component.html',
  styleUrls: ['./fiche-footing.component.css']
})
export class FicheFootingComponent implements OnInit {
  @Output() getModelesFiches = new EventEmitter();

  @Input()  selection;
  @Input()  isDeleteAllowed;

  constructor() { }

  ngOnInit() {
  }

}
